export default {
    title: 'My Assignments',
    hero: {
        bgAlt: 'Amusement park background',
        panelAlt: 'My Assignments title panel',
        title: 'My Assignments',
        description: 'Check the assignments your teacher gave you and complete them one step at a time.',
    },
    aria: {
        boardLabel: 'Assignment board',
        tabsLabel: 'Assignment status tabs',
        progress: 'Assignment progress {percent}%',
        actionButton: '{title} {label}',
    },
    tabs: {
        active: 'In Progress',
        ended: 'Closed',
    },
    meta: {
        activityCount: 'Activities',
        createdAt: 'Created',
        endedAt: 'Ended',
    },
    status: {
        before: 'Not started',
        inprogress: 'In progress',
        complete: 'Completed',
        endedComplete: 'Completed',
        endedIncomplete: 'Incomplete',
    },
    actions: {
        view: 'View assignment',
        studyComplete: 'Completed',
        viewResult: 'View results',
    },
    stamp: {
        alt: 'Completed stamp',
    },
    empty: {
        active: 'No assignments in progress.',
        ended: 'No closed assignments.',
    },
    activity: {
        name: 'Activity {index}',
    },
    modal: {
        closeAria: 'Close modal',
        close: 'Close',
        start: 'Start',
    },
    flash: {
        title: {
            info: 'Notice',
            warning: 'Warning',
            error: 'Error',
        },
        confirm: 'OK',
    },
};
